/**
 * @file entry
 * @author huyang(huyang2229@gmail.com)
 */

import Vue from 'vue';
import {
    Vuetify,
    VBtn,
    VApp,
    VList,
    VIcon,
    VProgressCircular,
    VGrid,
    VSelect,
    VTextField,
    VCard,
    VMenu,
    VDataTable,
    VSnackbar
} from 'vuetify';
import {createRouter} from './router';
import store from './store';
import App from './App.vue';
import Icon from 'vue-awesome/components/Icon.vue';
import DatePicker from 'iview/src/components/date-picker'
import 'iview/dist/styles/iview.css';


Vue.use(Vuetify, {
    components: {
        VApp,
        VBtn,
        VList,
        VIcon,
        VProgressCircular,
        VGrid,
        VSelect,
        VTextField,
        VMenu,
        VCard,
        VDataTable,
        VSnackbar
    }
});

Vue.component('icon', Icon);
Vue.component('DatePicker', DatePicker)


Vue.config.productionTip = false;

/* eslint-disable no-new */
export function createApp() {
    let router = createRouter();
    let app = new Vue({
        router,
        store,
        ...App
    });
    return {app, router, store};
}
Icon.register(
            {
                'svg-sentiment-very-satisfied': {
                    width: 48,
                    height: 48,
                    d: 'M23.99 4C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zm2-20.12L28.12 22l2.12-2.12L32.36 22l2.13-2.12-4.25-4.24zm-8.24 0L19.88 22 22 19.88l-4.24-4.24-4.25 4.24L15.64 22zM24 35c4.66 0 8.62-2.92 10.22-7H13.78c1.6 4.08 5.56 7 10.22 7z'
                }
            });


// WEBPACK FOOTER //
// ./src/app.js